import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Clear tokens from localStorage or sessionStorage
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');

        // Optionally clear other user-related data
        localStorage.removeItem('user');

        // Redirect to login page


        navigate('/login/');
    };

    useEffect(()=>{
        handleLogout();
    },[])
    return (
        <>
            <h1>Logged Out</h1>
        </>
    );
};

export default Logout;